import { Link, createFileRoute } from '@tanstack/react-router'
import { Table } from 'antd'
import { useEffect, useState } from 'react'
import { useUsers } from '../hooks/useUsers'
import { getPagination } from '../components/TablePagination'

// 用户查询参数类型
interface UserQueryParams {
  pageNum: string
  pageSize: string
}

const columns = [
  {
    title: '用户 ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'OpenID',
    dataIndex: 'openId',
    key: 'openId',
  },
  // {
  //   title: '订单数',
  //   dataIndex: 'orderCount',
  //   key: 'orderCount',
  //   render: (count: number, record: any) => (
  //     <Link to="/order" search={{ userId: record.id }}>
  //       {count}
  //     </Link>
  //   ),
  // },
  {
    title: '注册时间',
    dataIndex: 'registerTime',
    key: 'registerTime',
  },
  {
    title: '最后登录时间',
    dataIndex: 'lastLoginTime',
    key: 'lastLoginTime',
  },
]

export const Route = createFileRoute('/user')({
  component: UserManagement,
})

function UserManagement() {
  // 从URL初始化搜索参数
  const [searchParams, setSearchParams] = useState<UserQueryParams>(() => {
    const search = new URLSearchParams(window.location.search)
    return {
      pageNum: search.get('pageNum') || '1',
      pageSize: search.get('pageSize') || '10',
    }
  })

  // 同步URL参数
  useEffect(() => {
    const params = new URLSearchParams()
    params.set('pageNum', searchParams.pageNum)
    params.set('pageSize', searchParams.pageSize)

    const newUrl = `${window.location.pathname}?${params.toString()}`
    window.history.replaceState(null, '', newUrl)
  }, [searchParams])

  const { data, isLoading } = useUsers(
    parseInt(searchParams.pageNum),
    parseInt(searchParams.pageSize),
  )

  // 处理表格分页变化
  const handlePaginationChange = (page: number, pageSize: number) => {
    setSearchParams((prev) => ({
      ...prev,
      pageNum: page.toString(),
      pageSize: pageSize.toString(),
    }))
  }

  const users = data?.records || []
  const total = data?.total || 0
  const pageNum = data?.current || 1
  const pageSize = data?.size || 10

  return (
    <div className="p-4">
      <h2 className="text-lg font-semibold mb-4">用户管理</h2>
      <Table
        bordered
        dataSource={users}
        columns={columns}
        rowKey="id"
        pagination={getPagination(
          pageNum,
          pageSize,
          total,
          handlePaginationChange,
        )}
        loading={isLoading}
      />
    </div>
  )
}
